export default "__VITE_ASSET__Cmr$qtlY__"